export const API_ORIGIN = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000';

export function apiUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_ORIGIN.replace(/\/$/, '')}${normalizedPath}`;
}
